import preLoader from 'core/loader'
import { TypeConfig, TypeTheme, defaultConfig, defaultTheme, defaultThemeB } from 'core/style/theme'

export class ConfigWebLib {
  partnerId: string
  config?: TypeConfig
  theme?: TypeTheme
  themeB?: TypeTheme
  constructor({ partnerId }: { partnerId: string }) {
    this.partnerId = partnerId
  }

  public async preload() {
    try {
      const { config, theme, themeB } = await preLoader(this.partnerId)
      this.config = config
      this.theme = theme
      this.themeB = themeB
    } catch (error) {
      this.config = defaultConfig
      this.theme = defaultTheme
      this.themeB = defaultThemeB
    }
  }

  public async configPending() {
    await new Promise((resolve) => {
      const checkConfig = () => {
        if (this.config) {
          resolve(1)
        } else {
          setTimeout(checkConfig, 100)
        }
      }
      checkConfig()
    })
  }
}
